import React, { Fragment } from "react"
import PropTypes from "prop-types"
import {
  format,
  startOfDay,
  formatDistance,
  differenceInCalendarDays,
} from "datastory-shared/utils/date"
import { Container, Box, Flex, TextXS, Accordion } from "datastory-shared/ui"

import { Item } from "./Item"

const getDataByMonth = data => {
  const dataWithMonth = data.map(i => ({
    ...i,
    month: format(
      new Date(i.date),
      {
        month: "long",
      },
      "en"
    ),
  }))

  const dataByMonth = {}
  dataWithMonth.forEach(i => {
    if (!dataByMonth[i.month]) {
      dataByMonth[i.month] = []
    }
    dataByMonth[i.month].push(i)
  })

  return dataByMonth
}

export const Timeline = ({ data }) => {
  const dataByMonth = getDataByMonth(data)
  const months = Object.keys(dataByMonth)

  return (
    <>
      <Container maxW="container.md" px={[0, 0, "inherit"]} position="relative">
        <Box
          w="2px"
          bg={"gray.100"}
          position="absolute"
          top={["-1rem", null, "3.5rem"]}
          left={[0, null, "calc(7rem - 5px)"]}
          bottom={"2rem"}
          zIndex={-1}
        />

        {months.map((month, monthIndex) => (
          <Fragment key={month}>
            {monthIndex !== 0 && (
              <Flex
                justifyContent="center"
                mt={["-md", null, "lg"]}
                mb={["lg"]}
              >
                <Box bg={"gray.50"} borderRadius="lg" ml={[0, null, "8rem"]}>
                  <TextXS
                    textAlign="center"
                    py="xs"
                    px="md"
                    color={"gray.700"}
                    lineHeight="shorter"
                    letterSpacing="wide"
                    fontWeight="600"
                  >
                    {month.toUpperCase()}
                  </TextXS>
                </Box>
              </Flex>
            )}
            <Accordion allowMultiple={true}>
              {dataByMonth[month].map((card, cardIndex) => (
                <Box key={card.id} position="relative">
                  <Box
                    position="absolute"
                    top={0}
                    bottom={0}
                    left={["1rem", null, 0]}
                    width={["auto", null, "7rem"]}
                    pt={[0, null, "3.125rem"]}
                    mt={["-1.75rem", null, 0]}
                  >
                    {monthIndex === months.length - 1 &&
                      cardIndex === dataByMonth[month].length - 1 && (
                        <Box
                          bg={"white"}
                          position="absolute"
                          top={["1rem", null, "3.5rem"]}
                          left={["-2rem", null, "auto"]}
                          bottom="0"
                          width="100%"
                          zIndex={-1}
                        />
                      )}

                    <Flex alignItems="center" justifyContent="flex-end">
                      <Box textAlign="right" pr={[0, null, "xs"]}>
                        <TextXS
                          fontWeight={600}
                          textTransform="uppercase"
                          whiteSpace="nowrap"
                          display={["inline", null, "block"]}
                        >
                          {differenceInCalendarDays(
                            new Date(card.date),
                            new Date()
                          ) < 11
                            ? formatDistance(
                                startOfDay(new Date(card.date)),
                                startOfDay(new Date()),
                                undefined,
                                "en"
                              )
                            : format(
                                new Date(card.date),
                                {
                                  month: "short",
                                  day: "numeric",
                                },
                                "en"
                              )}
                        </TextXS>
                      </Box>
                      <Box
                        position={["absolute", null, "static"]}
                        left={["calc(-1rem - 3px)", null, "auto"]}
                        top={["10px", null, "auto"]}
                      >
                        <Box
                          borderRadius="100%"
                          bg={"black"}
                          width="8px"
                          height="8px"
                        />
                      </Box>
                    </Flex>
                  </Box>

                  <Item card={card} />
                </Box>
              ))}
            </Accordion>
          </Fragment>
        ))}
      </Container>
    </>
  )
}

Timeline.propTypes = {
  data: PropTypes.array,
}
